// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"i_a","header":"i_b","content":"i_c","footer":"i_d","skip-nav-link":"i_e"};